/**
 * ⚠️ PLACEHOLDER SERVICES
 * 
 * These functions return mock data for frontend development.
 * All functions are documented in read-functions.md for backend implementation.
 * 
 * @see /read-functions.md for backend requirements
 */

import type { LoyaltyCard, User, CoffeeShop } from '@/types'

// ===========================================
// AUTHENTICATION (Placeholder)
// ===========================================

/**
 * @placeholder Documented in read-functions.md
 * @module Authentication
 */
export async function signIn(_email: string, _password: string): Promise<{ user: User | null; error: string | null }> {
    // MOCK: Simulates successful login
    return {
        user: {
            id: 'mock-user-1',
            email: 'usuario@exemplo.com',
            name: 'Usuário Teste',
            avatarUrl: null,
            createdAt: new Date().toISOString(),
        },
        error: null,
    }
}

/**
 * @placeholder Documented in read-functions.md
 * @module Authentication
 */
export async function signOut(): Promise<{ error: string | null }> {
    return { error: null }
}

/**
 * @placeholder Documented in read-functions.md
 * @module Authentication
 */
export async function getCurrentUser(): Promise<User | null> {
    // MOCK: Returns null (not logged in) for development
    return null
}

// ===========================================
// LOYALTY CARDS (Placeholder)
// ===========================================

/**
 * @placeholder Documented in read-functions.md
 * @module Loyalty Cards
 */
export async function getUserLoyaltyCards(_userId: string): Promise<LoyaltyCard[]> {
    // MOCK DATA
    return [
        {
            id: 'card-1',
            shopId: 'shop-1',
            shopName: 'Café Central',
            shopLogo: null,
            currentStamps: 5,
            totalStamps: 10,
            reward: 'Café grátis',
            expiresAt: null,
        },
        {
            id: 'card-2',
            shopId: 'shop-2',
            shopName: 'Bean House',
            shopLogo: null,
            currentStamps: 3,
            totalStamps: 8,
            reward: '20% de desconto',
            expiresAt: '2025-03-01',
        },
    ]
}

/**
 * @placeholder Documented in read-functions.md
 * @module Loyalty Cards
 */
export async function addStamp(_cardId: string): Promise<{ success: boolean; error: string | null }> {
    return { success: true, error: null }
}

// ===========================================
// COFFEE SHOPS (Placeholder)
// ===========================================

/**
 * @placeholder Documented in read-functions.md
 * @module Coffee Shops
 */
export async function getNearbyCoffeeShops(_lat: number, _lng: number): Promise<CoffeeShop[]> {
    // MOCK DATA
    return [
        {
            id: 'shop-1',
            name: 'Café Central',
            address: 'Rua das Flores, 123',
            lat: -23.550520,
            lng: -46.633309,
            rating: 4.5,
            isOpen: true,
            hasLoyaltyProgram: true,
        },
        {
            id: 'shop-2',
            name: 'Bean House',
            address: 'Av. Paulista, 456',
            lat: -23.561414,
            lng: -46.656013,
            rating: 4.2,
            isOpen: false,
            hasLoyaltyProgram: true,
        },
    ]
}

/**
 * @placeholder Documented in read-functions.md
 * @module Coffee Shops
 */
export async function getCoffeeShopById(_shopId: string): Promise<CoffeeShop | null> {
    return null
}

// ===========================================
// WAITLIST (Placeholder)
// ===========================================

/**
 * @placeholder Documented in read-functions.md
 * @module Waitlist
 * @status awaiting-backend
 */
export async function joinBusinessWaitlist(data: {
    name: string;
    email: string;
    shopName?: string;
}): Promise<{ success: boolean; error: string | null }> {
    // MOCK: Simulates successful waitlist registration
    console.log('[PLACEHOLDER] Waitlist entry:', data);
    await new Promise((resolve) => setTimeout(resolve, 800)); // Simulate network delay
    return { success: true, error: null };
}
